import React, {Component} from 'react';
import {ModalBody, ModalFooter} from "reactstrap";
import { withTranslation } from 'react-i18next';

class AddNoteForm extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        const noteText = event.target.note.value;
        this.props.onSubmit(noteText)
    }

    renderSaveButton() {
        const { t } = this.props;
        return <input type="submit" value={t('add_button')} className="btn -alt"/>
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody className="crm-modal-body">
                    <div className="modal-section">
                        <div className="form-row">
                            <textarea className="textarea" name="note"/>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}

export default withTranslation()(AddNoteForm);
